import React, { FC } from "react";
import { Dialog, makeStyles } from "@material-ui/core";
import { connect } from "react-redux";
import type { IStore } from "reducers";
import { InlineLoading } from "components/content-loading";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

export interface IStateProps {
    message: string;
}

const AppLoader: FC<IStateProps> = ({ message }) => {
    const classes = useStyles();

    return (
        !!message && (
            <Dialog disableScrollLock open={!!message} classes={{ paper: classes.paper }}>
                <DialogContent className={classes.content}>
                    <DialogContentText className={classes.contextText}>{message}</DialogContentText>
                    <InlineLoading className={classes.loadingContainer} />
                </DialogContent>
            </Dialog>
        )
    );
};

const useStyles = makeStyles({
    paper: {
        width: "100%",
        maxWidth: "360px",
    },
    content: {
        padding: "12px 24px",
    },
    contextText: {
        fontSize: "16px",
        fontFamily: "Lato, sans-serif",
        color: "rgba(45,45,45,0.6)",
    },
    loadingContainer: {
        padding: "16px",
    },
});

const mapStateToProps = (state: IStore): IStateProps => ({
    message: state.loader.messages?.[0]?.message,
});

export default connect<IStateProps, {}, {}>(mapStateToProps, null)(AppLoader);
